<section class="playground">
  <h2 class="playground__heading">Icon button</h2>
  <p class="playground__hint">
    <code>common-icon-button</code> — dos variantes (<code>default</code> con mat-icon-button y <code>plain</code>
    solo-icono), colores, tamaños, iconFill, loading/disabled y padding simétrico.
  </p>

  <!-- ── Controles + preview interactivo ──────────────────────────────────── -->
  <div class="playground__grid">
    <div class="playground__controls">

      <label class="playground__field">
        <span>variant</span>
        <select [(ngModel)]="variant">
          <option *ngFor="let v of variants" [value]="v">{{ v }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>icon (Material Symbols)</span>
        <input type="text" [(ngModel)]="icon" />
      </label>

      <label class="playground__field">
        <span>iconSet</span>
        <select [(ngModel)]="iconSet">
          <option *ngFor="let s of iconSets" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>ariaLabel</span>
        <input type="text" [(ngModel)]="ariaLabel" />
      </label>

      <!-- default-only -->
      <ng-container *ngIf="!isPlain">
        <label class="playground__field">
          <span>color</span>
          <select [(ngModel)]="color">
            <option *ngFor="let c of colors" [value]="c">{{ c }}</option>
          </select>
        </label>

        <label class="playground__field">
          <span>size</span>
          <select [(ngModel)]="size">
            <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
          </select>
        </label>

        <label class="playground__field">
          <span>backgroundOpacity (0–1, opcional)</span>
          <input
            type="number" min="0" max="1" step="0.05"
            [ngModel]="backgroundOpacity"
            (ngModelChange)="backgroundOpacity = $event === '' || $event === null ? null : +$event"
          />
        </label>
      </ng-container>

      <!-- plain-only -->
      <ng-container *ngIf="isPlain">
        <label class="playground__field">
          <span>iconPadding (px simétrico, 0 = 24×24 exacto)</span>
          <input type="number" min="0" max="32" step="2" [(ngModel)]="iconPadding" />
        </label>

        <label class="playground__field">
          <span>backgroundOpacity (0–1, solo con iconPadding &gt; 0)</span>
          <input
            type="number" min="0" max="1" step="0.05"
            [ngModel]="backgroundOpacity"
            (ngModelChange)="backgroundOpacity = $event === '' || $event === null ? null : +$event"
          />
        </label>

        <label class="playground__field playground__field--checkbox">
          <input type="checkbox" [(ngModel)]="iconFill" />
          <span>iconFill</span>
        </label>
      </ng-container>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="loading" />
        <span>loading</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview interactivo</p>
      <div class="playground__preview-box">
        <common-icon-button
          [variant]="variant"
          [icon]="icon"
          [iconSet]="iconSet"
          [ariaLabel]="ariaLabel"
          [color]="color"
          [size]="size"
          [disabled]="disabled"
          [loading]="loading"
          [iconFill]="iconFill"
          [backgroundOpacity]="backgroundOpacity"
          [iconPadding]="iconPadding"
          (output)="onClick()"
        ></common-icon-button>
      </div>
      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>

  <!-- ── Catálogo estático: variant="default" ───────────────────────────────── -->
  <h3 class="playground__section-title">Catálogo — variant="default"</h3>
  <p class="playground__section-hint">Color (filas) × Size (columnas)</p>

  <div class="playground__catalog-table">
    <!-- header -->
    <div class="playground__catalog-header">
      <span class="playground__catalog-cell playground__catalog-cell--label"></span>
      <span *ngFor="let s of sizes" class="playground__catalog-cell playground__catalog-cell--label">{{ s }}</span>
    </div>
    <!-- rows -->
    <div *ngFor="let c of colors" class="playground__catalog-row">
      <span class="playground__catalog-cell playground__catalog-cell--label">{{ c }}</span>
      <span *ngFor="let s of sizes" class="playground__catalog-cell">
        <common-icon-button
          [icon]="icon"
          [color]="c"
          [size]="s"
          type="filled"
          (output)="onClick()"
        ></common-icon-button>
      </span>
    </div>
    <!-- disabled row -->
    <div class="playground__catalog-row">
      <span class="playground__catalog-cell playground__catalog-cell--label playground__catalog-cell--muted">disabled</span>
      <span *ngFor="let s of sizes" class="playground__catalog-cell">
        <common-icon-button [icon]="icon" color="primary" [size]="s" [disabled]="true"></common-icon-button>
      </span>
    </div>
    <!-- loading row -->
    <div class="playground__catalog-row">
      <span class="playground__catalog-cell playground__catalog-cell--label playground__catalog-cell--muted">loading</span>
      <span *ngFor="let s of sizes" class="playground__catalog-cell">
        <common-icon-button [icon]="icon" color="primary" [size]="s" [loading]="true"></common-icon-button>
      </span>
    </div>
  </div>

  <!-- ── Catálogo estático: variant="plain" ────────────────────────────────── -->
  <h3 class="playground__section-title">Catálogo — variant="plain"</h3>

  <div class="playground__plain-catalog">
    <div *ngFor="let sample of plainPaddingSamples" class="playground__plain-sample">
      <p class="playground__plain-label">{{ sample.label }}</p>
      <div class="playground__plain-box">
        <!-- icono normal -->
        <common-icon-button
          variant="plain"
          [icon]="icon"
          [iconPadding]="sample.padding"
          [backgroundOpacity]="sample.opacity"
          (output)="onClick()"
        ></common-icon-button>
        <!-- iconFill -->
        <common-icon-button
          variant="plain"
          icon="favorite"
          [iconPadding]="sample.padding"
          [backgroundOpacity]="sample.opacity"
          [iconFill]="true"
          (output)="onClick()"
        ></common-icon-button>
        <!-- disabled -->
        <common-icon-button
          variant="plain"
          [icon]="icon"
          [iconPadding]="sample.padding"
          [backgroundOpacity]="sample.opacity"
          [disabled]="true"
        ></common-icon-button>
      </div>
    </div>
  </div>

</section>
